export default __webpack_public_path__ + "static/media/snow.df7d8563.svg";